import script from "./AboutUs.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=208e9bea&lang=less&scoped=true"
import "./AboutUs.vue?vue&type=style&index=1&id=208e9bea&lang=less"

import exportComponent from "/data/web/pay/idpay/idpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-208e9bea"]])

export default __exports__